export const SampleData = [
  {
    no: 1,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1516",
        target: "_blank",
        children: "DBM-1516"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (CLRWorks) - LPL Account Section",
    points: 2,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation hollll",
    labels: ""
  },
  {
    no: 2,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1416",
        target: "_blank",
        children: "DBM-1416"
      },
      _owner: null,
      _store: {}
    },
    desc: "Trade-blotter - STO report generation ",
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 3,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1332",
        target: "_blank",
        children: "DBM-1332"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Convert Dormant Account Task - Alert Update once task becomes Past Due",
    points: 2,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10,\nSprint 3-Convert Dormant Acc.",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 4,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1331",
        target: "_blank",
        children: "DBM-1331"
      },
      _owner: null,
      _store: {}
    },
    desc: "Convert Dormant Account Task - Due Date Logic",
    points: 1,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10,\nSprint 3-Convert Dormant Acc.",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 5,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1330",
        target: "_blank",
        children: "DBM-1330"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (ORT) - Alert Update ",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 6,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1329",
        target: "_blank",
        children: "DBM-1329"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (ORT) - Due Date Logic ",
    points: 1,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 7,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1328",
        target: "_blank",
        children: "DBM-1328"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (ORT) - List Page ",
    points: 2,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 8,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1327",
        target: "_blank",
        children: "DBM-1327"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (ORT) -Dashboard Screen",
    points: 1,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 9,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1179",
        target: "_blank",
        children: "DBM-1179"
      },
      _owner: null,
      _store: {}
    },
    desc: "Convert Dormant Account Task - Communication Panel ",
    points: 5,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10,\nSprint 3-Convert Dormant Acc.",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 10,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-835",
        target: "_blank",
        children: "DBM-835"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Convert Dormant Account Task - Refresh trades for dormant account received from the trade blotter",
    points: 1,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 11,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-461",
        target: "_blank",
        children: "DBM-461"
      },
      _owner: null,
      _store: {}
    },
    desc: "Trade Blotter Monitoring of Missing Suitability",
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In Development",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 12,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-460",
        target: "_blank",
        children: "DBM-460"
      },
      _owner: null,
      _store: {}
    },
    desc: "Trade Blotter will generate the tasks to ACT & ORT/ CLRWorks",
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 13,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-459",
        target: "_blank",
        children: "DBM-459"
      },
      _owner: null,
      _store: {}
    },
    desc: "Trade Blotter Loading Process",
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 14,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CS-2672",
        target: "_blank",
        children: "CS-2672"
      },
      _owner: null,
      _store: {}
    },
    desc: "Additional Application Statuses Coming From CLO",
    sprint: "\nCS Sprint 20",
    status: "Ready for Backlog Refinement",
    project: "Capital Solutions Lending System",
    labels: ""
  },
  {
    no: 15,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CS-2639",
        target: "_blank",
        children: "CS-2639"
      },
      _owner: null,
      _store: {}
    },
    desc: "Dashboard Disclaimer - Balances As Of Previous Day",
    sprint: "\nCS Sprint 20",
    status: "Done",
    project: "Capital Solutions Lending System",
    labels: ""
  },
  {
    no: 16,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CS-2601",
        target: "_blank",
        children: "CS-2601"
      },
      _owner: null,
      _store: {}
    },
    desc: "Fix Typo on Acquisition Loan Calculator",
    points: 1,
    sprint: "\nCS Sprint 19",
    status: "In Development",
    project: "Capital Solutions Lending System",
    labels: ""
  },
  {
    no: 17,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CS-2586",
        target: "_blank",
        children: "CS-2586"
      },
      _owner: null,
      _store: {}
    },
    desc: "Update Acquisition Loan Calculator Footnotes to Newest Copy",
    points: 1,
    sprint: "\nCS Sprint 19",
    status: "In Development",
    project: "Capital Solutions Lending System",
    labels: ""
  },
  {
    no: 18,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CS-2564",
        target: "_blank",
        children: "CS-2564"
      },
      _owner: null,
      _store: {}
    },
    desc: "Forgivable Loans on Dashboard",
    sprint: "\nCS Sprint 19",
    status: "In Development",
    project: "Capital Solutions Lending System",
    labels: ""
  },
  {
    no: 19,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CS-2563",
        target: "_blank",
        children: "CS-2563"
      },
      _owner: null,
      _store: {}
    },
    desc: "Replacement Payment Logic and Text",
    points: 5,
    sprint: "\nCS Sprint 19",
    status: "In Development",
    project: "Capital Solutions Lending System",
    labels: ""
  },
  {
    no: 20,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CS-2562",
        target: "_blank",
        children: "CS-2562"
      },
      _owner: null,
      _store: {}
    },
    desc: "Online Services Agreement",
    sprint: "",
    status: "Backlog",
    project: "Capital Solutions Lending System",
    labels: ""
  },
  {
    no: 21,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CS-2561",
        target: "_blank",
        children: "CS-2561"
      },
      _owner: null,
      _store: {}
    },
    desc: "Update FAQ Wording",
    points: 1,
    sprint: "\nCS Sprint 19",
    status: "In Development",
    project: "Capital Solutions Lending System",
    labels: ""
  },
  {
    no: 22,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CS-2262",
        target: "_blank",
        children: "CS-2262"
      },
      _owner: null,
      _store: {}
    },
    desc: "RepId Fields and $ sign are missing from configure Email body ",
    sprint: "\nCS Sprint 19",
    status: "In Development",
    project: "Capital Solutions Lending System",
    labels: ""
  },
  {
    no: 23,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CRMT-1365",
        target: "_blank",
        children: "CRMT-1365"
      },
      _owner: null,
      _store: {}
    },
    desc: "Dynamics: Mule Upgrade",
    points: 3,
    sprint: "\nCRMT Sprint 40 (20.5.5)",
    status: "In Development",
    project: "Jedi Knights - CWC: Client Works Connected",
    labels: ""
  },
  {
    no: 24,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CRMT-1293",
        target: "_blank",
        children: "CRMT-1293"
      },
      _owner: null,
      _store: {}
    },
    desc: "Snappy Kraken - System Update – API Remediation code (using API)  ",
    points: 5,
    sprint:
      "\nCRMT Sprint 37 (20.5.2),\nCRMT Sprint 38 (20.5.3),\nCRMT Sprint 40 (20.5.5),\nCRMT Sprint 39 (20.5.4)",
    status: "In Development",
    project: "Jedi Knights - CWC: Client Works Connected",
    labels: "\nSnappyKraken"
  },
  {
    no: 25,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CRMT-1292",
        target: "_blank",
        children: "CRMT-1292"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Snappy Kraken System Update – Mulesoft Activity Ingestion from SK API",
    sprint: "\nCRMT Sprint 40 (20.5.5),\nCRMT Sprint 39 (20.5.4)",
    status: "In Development",
    project: "Jedi Knights - CWC: Client Works Connected",
    labels: ""
  },
  {
    no: 26,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/CRMT-1291",
        target: "_blank",
        children: "CRMT-1291"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Snappy Kraken System Update – Configure Electronic Communications Reconciler code ",
    points: 5,
    sprint:
      "\nCRMT Sprint 37 (20.5.2),\nCRMT Sprint 38 (20.5.3),\nCRMT Sprint 40 (20.5.5),\nCRMT Sprint 39 (20.5.4)",
    status: "In QA",
    project: "Jedi Knights - CWC: Client Works Connected",
    labels: "\nSnappyKraken"
  },
  {
    no: 27,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/BDFFC-270",
        target: "_blank",
        children: "BDFFC-270"
      },
      _owner: null,
      _store: {}
    },
    desc: "Documentum/Captiva changes for FORM CRS MAIL failures",
    sprint: "",
    status: "Sprint Backlog",
    project: "BIS - Disclosures, Forms and Form CRS",
    labels: ""
  },
  {
    no: 28,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/BDFFC-190",
        target: "_blank",
        children: "BDFFC-190"
      },
      _owner: null,
      _store: {}
    },
    desc: "Automation to capture EMAIL failures in audit log",
    sprint: "\nBDFFC Sprint  21,\nBDFFC Sprint  22",
    status: "In Development",
    project: "BIS - Disclosures, Forms and Form CRS",
    labels: ""
  },
  {
    no: 29,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/AVMDC-1860",
        target: "_blank",
        children: "AVMDC-1860"
      },
      _owner: null,
      _store: {}
    },
    desc: "(Ave OUT) [MapR] - Client Letters Paperless Setting View",
    points: 5,
    sprint: "\n20.5.4",
    status: "Done",
    project: "The Mandalorians: Web and Mobile",
    labels: "\nNo_UAT"
  },
  {
    no: 30,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/APA-1139",
        target: "_blank",
        children: "APA-1139"
      },
      _owner: null,
      _store: {}
    },
    desc: "M&A Solutions - ClientWorks - Update the TASK card layout (MVP)",
    sprint: "\nGame of Scrums Sprint 18",
    status: "Backlog",
    project: "Advisor Practices Acquisition",
    labels: "\nAPA_HO_CW"
  },
  {
    no: 31,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/APA-1083",
        target: "_blank",
        children: "APA-1083"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Assurance Plan - Home Office - Sync db. for 'BP' Rep Type details only with CommReg (MVP)",
    points: 8,
    sprint: "\nGame of Scrums Sprint 17",
    status: "In Development",
    project: "Advisor Practices Acquisition",
    labels: "\nAPA_HO_CW"
  },
  {
    no: 32,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/APA-990",
        target: "_blank",
        children: "APA-990"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Home Office - M&A Solutions - Check for any edits prior navigating user away from page in focus (MVP)",
    points: 5,
    sprint: "\nGame of Scrums Sprint 16,\nGame of Scrums Sprint 17",
    status: "In QA",
    project: "Advisor Practices Acquisition",
    labels: "\nAPA_HO_CW"
  },
  {
    no: 33,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/APA-974",
        target: "_blank",
        children: "APA-974"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Home Office - Deal Execution - Move Notifications to the higher nav. bar (MVP)",
    points: 3,
    sprint: "\nGame of Scrums Sprint 16,\nGame of Scrums Sprint 17",
    status: "In QA",
    project: "Advisor Practices Acquisition",
    labels: "\nAPA_HO_CW"
  },
  {
    no: 34,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/APA-958",
        target: "_blank",
        children: "APA-958"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Home office - Document Sharing - Create sub-folders under Buying & Selling advisor BOX folders (MVP)",
    points: 5,
    sprint: "\nGame of Scrums Sprint 16,\nGame of Scrums Sprint 17",
    status: "Ready for Testing",
    project: "Advisor Practices Acquisition",
    labels: "\nAPA_HO_CW"
  },
  {
    no: 35,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/APA-943",
        target: "_blank",
        children: "APA-943"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "ClientWorks - Sync Deal Specialist images b/w SharePoint & BOX folder",
    points: 8,
    sprint:
      "\nGame of Scrums Sprint 15,\nGame of Scrums Sprint 16,\nGame of Scrums Sprint 17",
    status: "In Development",
    project: "Advisor Practices Acquisition",
    labels: "\nAPA_HO_CW"
  },
  {
    no: 36,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/APA-275",
        target: "_blank",
        children: "APA-275"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Home office - Deal Library - Ability to reorder the sequence of tasks (MVP)",
    points: 5,
    sprint: "\nGame of Scrums Sprint 16,\nGame of Scrums Sprint 17",
    status: "In QA",
    project: "Advisor Practices Acquisition",
    labels: "\nAPA_HO_CW"
  },
  {
    no: 37,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UG-94",
        target: "_blank",
        children: "UG-94"
      },
      _owner: null,
      _store: {}
    },
    desc: "ADA Compliance: Testing",
    sprint: "\nUG Sprint 4,\nUG Sprint 5",
    status: "In QA",
    project: "UTMA/UGMA - ACT",
    labels: ""
  },
  {
    no: 38,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5617",
        target: "_blank",
        children: "UASOA-5617"
      },
      _owner: null,
      _store: {}
    },
    desc: "CLONE - QA- Composite MMS calls for MasterModel",
    points: 8,
    sprint: "\n20.6.1 Titans",
    status: "Backlog",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 39,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5590",
        target: "_blank",
        children: "UASOA-5590"
      },
      _owner: null,
      _store: {}
    },
    desc: "Loading SEC_XRF file into Datalake",
    sprint: "\n20.5.5 Plutus",
    status: "Backlog",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 40,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5577",
        target: "_blank",
        children: "UASOA-5577"
      },
      _owner: null,
      _store: {}
    },
    desc: "SLA Improvement for 2500 Enrichment Solution",
    points: 3,
    sprint: "\n20.5.5 Plutus",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 41,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5576",
        target: "_blank",
        children: "UASOA-5576"
      },
      _owner: null,
      _store: {}
    },
    desc: "1000 load Stage_Store Improvements",
    points: 3,
    sprint: "\n20.5.5 Plutus",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 42,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5499",
        target: "_blank",
        children: "UASOA-5499"
      },
      _owner: null,
      _store: {}
    },
    desc: "4000 Master Security Solution Improvement",
    sprint: "\n20.5.5 Plutus",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 43,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5488",
        target: "_blank",
        children: "UASOA-5488"
      },
      _owner: null,
      _store: {}
    },
    desc: "Duplicate Cusip entries from ICE file",
    sprint: "\n20.5.5 Plutus",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 44,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5486",
        target: "_blank",
        children: "UASOA-5486"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Tech Story: Process MM multiple requests without interruption if any request “timeout” in between",
    sprint: "\n20.5.5 Captain America",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 45,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5452",
        target: "_blank",
        children: "UASOA-5452"
      },
      _owner: null,
      _store: {}
    },
    desc: "Update DIS Job Dependency for 4000 Master Price  Solution",
    points: 2,
    sprint: "\n20.5.5 Plutus",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 46,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5346",
        target: "_blank",
        children: "UASOA-5346"
      },
      _owner: null,
      _store: {}
    },
    desc: "Tech: System Logging enhancement to ModelPortfolioRequest service",
    points: 8,
    sprint: "\n20.5.5 Captain America",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 47,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5342",
        target: "_blank",
        children: "UASOA-5342"
      },
      _owner: null,
      _store: {}
    },
    desc: "IIS806 OPMG Automation - Bulk Update - Custom Cash Template",
    points: 5,
    sprint: "\n20.5.5 Captain America",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 48,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5265",
        target: "_blank",
        children: "UASOA-5265"
      },
      _owner: null,
      _store: {}
    },
    desc: "TECH Only - Composite MMS calls for MasterModel",
    points: 8,
    sprint: "\n20.5.5 Titans",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 49,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5184",
        target: "_blank",
        children: "UASOA-5184"
      },
      _owner: null,
      _store: {}
    },
    desc: "EDM - Refresh the price mastering data after latest POS is loaded",
    points: 3,
    sprint: "\n20.5.5 Plutus",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: "\nEDM"
  },
  {
    no: 50,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-5003",
        target: "_blank",
        children: "UASOA-5003"
      },
      _owner: null,
      _store: {}
    },
    desc: "Licensing Check (CAO): Import Allocations Spreadsheet - IAR",
    points: 5,
    sprint: "\n20.5.4 Avengers",
    status: "Done",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: "\n20.5.4"
  },
  {
    no: 51,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-4974",
        target: "_blank",
        children: "UASOA-4974"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Securities with security types MM and CH should be filtered out of security and pricing files to Tegra",
    sprint: "\n20.5.5 Plutus",
    status: "In QA",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: ""
  },
  {
    no: 52,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-4494",
        target: "_blank",
        children: "UASOA-4494"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Licensing Check (CAO): Advisor Delegate - Create/Edit Model - IAR (Dev Only)",
    points: 5,
    sprint: "\n20.5.4 Avengers",
    status: "Done",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: "\n20.5.4"
  },
  {
    no: 53,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-4493",
        target: "_blank",
        children: "UASOA-4493"
      },
      _owner: null,
      _store: {}
    },
    desc: "Licensing Check (CAO): Advisor Admin - Create/Edit Model - IAR",
    points: 8,
    sprint: "\n20.5.4 Avengers",
    status: "Done",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: "\n20.5.4"
  },
  {
    no: 54,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-4490",
        target: "_blank",
        children: "UASOA-4490"
      },
      _owner: null,
      _store: {}
    },
    desc: "Licensing Check (CAO): Advisor Admin Tab - IAR Approval Checks",
    points: 13,
    sprint: "\n20.5.4 Avengers",
    status: "Done",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: "\n20.5.3"
  },
  {
    no: 55,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-4302",
        target: "_blank",
        children: "UASOA-4302"
      },
      _owner: null,
      _store: {}
    },
    desc: "CC 30 Day Notification - Enhancement",
    points: 3,
    sprint: "\n20.5.5 Captain America",
    status: "In QA",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: "\n20.5.5_Candidate,\nNotifications"
  },
  {
    no: 56,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-4301",
        target: "_blank",
        children: "UASOA-4301"
      },
      _owner: null,
      _store: {}
    },
    desc: "Below Minimum Notification - Enhancement",
    points: 3,
    sprint: "\n20.5.5 Captain America",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: "\n20.5.5_Candidate,\nNotifications"
  },
  {
    no: 57,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-4134",
        target: "_blank",
        children: "UASOA-4134"
      },
      _owner: null,
      _store: {}
    },
    desc: "TECH : EDM - Deployment and Production Support",
    points: 4,
    sprint: "\n20.5.5 Plutus",
    status: "In Development",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: "\nEDM-ICE"
  },
  {
    no: 58,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-4126",
        target: "_blank",
        children: "UASOA-4126"
      },
      _owner: null,
      _store: {}
    },
    desc: "TECH : EDM - Implementing the logic to send securities to Tegra",
    points: 2,
    sprint: "\n20.5.5 Plutus",
    status: "In QA",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: "\nEDM-ICE"
  },
  {
    no: 59,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/UASOA-4098",
        target: "_blank",
        children: "UASOA-4098"
      },
      _owner: null,
      _store: {}
    },
    desc: "TECH : EDM - End to End testing and scheduling",
    points: 4,
    sprint: "\n20.5.5 Plutus",
    status: "Backlog",
    project: "UMA - Advisor Sleeve / OPMG Automation",
    labels: "\nEDM-ICE"
  },
  {
    no: 60,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1298",
        target: "_blank",
        children: "TT4B-1298"
      },
      _owner: null,
      _store: {}
    },
    desc: "TESTING - Database schema to support new TCE strucure",
    points: 5,
    sprint: "\nTT4B Sprint 16",
    status: "Ready for Testing",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nTCE"
  },
  {
    no: 61,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1297",
        target: "_blank",
        children: "TT4B-1297"
      },
      _owner: null,
      _store: {}
    },
    desc: "TESTING - (CoT) FI Ticket Charge and Trade Fee Support ",
    points: 3,
    sprint: "\nTT4B Sprint 16",
    status: "In QA",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM"
  },
  {
    no: 62,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1296",
        target: "_blank",
        children: "TT4B-1296"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "TESTING - (CoT Service) Brokerage Account Rep Ticket Charge Trade Results from ComReg ",
    points: 8,
    sprint: "\nTT4B Sprint 16",
    status: "In QA",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM"
  },
  {
    no: 63,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1294",
        target: "_blank",
        children: "TT4B-1294"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "TESTING - (CoT Service) Advisory Account Client Ticket Charge Trade Results ",
    points: 8,
    sprint: "\nTT4B Sprint 16",
    status: "In QA",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM"
  },
  {
    no: 64,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1293",
        target: "_blank",
        children: "TT4B-1293"
      },
      _owner: null,
      _store: {}
    },
    desc: "TESTING- (Cont.) - Admin UI for Ticket Charge Proration process",
    points: 5,
    sprint: "\nTT4B Sprint 16",
    status: "Ready for Testing",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nProration"
  },
  {
    no: 65,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1292",
        target: "_blank",
        children: "TT4B-1292"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "TESTING - Pull the split information in COT for the split reps using LPL SQL db. ",
    points: 3,
    sprint: "\nTT4B Sprint 16",
    status: "In QA",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM"
  },
  {
    no: 66,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1291",
        target: "_blank",
        children: "TT4B-1291"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "TESTING - (CoT Service) Affiliation Model Display Flag and Send Ticket Charge to Beta Flag ",
    points: 5,
    sprint: "\nTT4B Sprint 16",
    status: "In QA",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nProration,\nTCE"
  },
  {
    no: 67,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1290",
        target: "_blank",
        children: "TT4B-1290"
      },
      _owner: null,
      _store: {}
    },
    desc: "TESTING - (CoT) AIOE Ticket Charge and Trade Fee Support ",
    points: 3,
    sprint: "\nTT4B Sprint 16",
    status: "In QA",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nQA_Only"
  },
  {
    no: 68,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1289",
        target: "_blank",
        children: "TT4B-1289"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "(CoT) Employee Related accounts- Equities and Fixed income-COT- $0 charges",
    sprint: "\nTT4B Sprint 16",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM"
  },
  {
    no: 69,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1288",
        target: "_blank",
        children: "TT4B-1288"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "(CoT) Additional Fields to be Sent to Comreg:  Effective Date, Commission Schedule ",
    points: 3,
    sprint: "\nTT4B Sprint 16",
    status: "In Development",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM"
  },
  {
    no: 70,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1286",
        target: "_blank",
        children: "TT4B-1286"
      },
      _owner: null,
      _store: {}
    },
    desc: "(CoT) UIT Ticket Charge and Trade Fee Support",
    points: 8,
    sprint: "\nTT4B - PI=2, Sprint 21.1.1",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM"
  },
  {
    no: 71,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1284",
        target: "_blank",
        children: "TT4B-1284"
      },
      _owner: null,
      _store: {}
    },
    desc: "Veracode remediation for TE, CoT, and EOServices",
    points: 8,
    sprint: "\nTT4B Sprint 16",
    status: "In Development",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nDEV_ONLY"
  },
  {
    no: 72,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1282",
        target: "_blank",
        children: "TT4B-1282"
      },
      _owner: null,
      _store: {}
    },
    desc: "(CoT) Return Ticket Charge for CDT/Scivantage Orders",
    sprint: "",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nCDT"
  },
  {
    no: 73,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1274",
        target: "_blank",
        children: "TT4B-1274"
      },
      _owner: null,
      _store: {}
    },
    desc: "Deploy Keras to IntraWeb servers",
    points: 3,
    sprint: "",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nDEV_ONLY"
  },
  {
    no: 74,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1273",
        target: "_blank",
        children: "TT4B-1273"
      },
      _owner: null,
      _store: {}
    },
    desc: "Create a dev-only report of market orders not executed",
    points: 3,
    sprint: "",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nDEV_ONLY"
  },
  {
    no: 75,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1272",
        target: "_blank",
        children: "TT4B-1272"
      },
      _owner: null,
      _store: {}
    },
    desc: "Add Market Center order type eligibility",
    points: 3,
    sprint: "",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nTrading_UAT"
  },
  {
    no: 76,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1269",
        target: "_blank",
        children: "TT4B-1269"
      },
      _owner: null,
      _store: {}
    },
    desc: "Add daily population of UITs into PDD to alleviate manual work",
    points: 5,
    sprint: "\nTT4B Sprint 16",
    status: "Ready for Testing",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nCLR_UAT,\nUAT_Only"
  },
  {
    no: 77,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1262",
        target: "_blank",
        children: "TT4B-1262"
      },
      _owner: null,
      _store: {}
    },
    desc: "(CoT) Maintenance Fee for AIOE",
    points: 5,
    sprint: "\nTT4B Sprint 16",
    status: "Ready for Testing",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM"
  },
  {
    no: 78,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1254",
        target: "_blank",
        children: "TT4B-1254"
      },
      _owner: null,
      _store: {}
    },
    desc: "Send TCE Utility Schedule Updates to Beta ",
    points: 5,
    sprint: "\nTT4B Sprint 16",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nTCE"
  },
  {
    no: 79,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1248",
        target: "_blank",
        children: "TT4B-1248"
      },
      _owner: null,
      _store: {}
    },
    desc: "Add additional Trading Eligibility fields in PDD",
    points: 5,
    sprint: "",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: ""
  },
  {
    no: 80,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1247",
        target: "_blank",
        children: "TT4B-1247"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Employee Model-(Linsco, Allan and Company , NYCB firms) - Use $0 ticket charge, 100% Payout and Trade Charge in COT service",
    points: 5,
    sprint: "\nTT4B Sprint 16",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: ""
  },
  {
    no: 81,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1234",
        target: "_blank",
        children: "TT4B-1234"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "(CoT) calculate the Payout, Surcharge, Gross Commision using CommReg value",
    points: 8,
    sprint: "\nTT4B Sprint 16",
    status: "In Development",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM"
  },
  {
    no: 82,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1226",
        target: "_blank",
        children: "TT4B-1226"
      },
      _owner: null,
      _store: {}
    },
    desc: "Add Custody Eligibility section to PDD",
    points: 5,
    sprint: "\nTT4B Sprint 16",
    status: "Ready for Testing",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nCLR_UAT,\nUAT_Only"
  },
  {
    no: 83,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1186",
        target: "_blank",
        children: "TT4B-1186"
      },
      _owner: null,
      _store: {}
    },
    desc: "Trade Edit for employee related accounts",
    points: 3,
    sprint: "",
    status: "In Development",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nMFTrading_UAT,\nTrading_UAT"
  },
  {
    no: 84,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1185",
        target: "_blank",
        children: "TT4B-1185"
      },
      _owner: null,
      _store: {}
    },
    desc: "Synch of Rep/Firm Overrides Legacy TCE and New TCE Central Utility",
    points: 8,
    sprint: "\nTT4B - PI=2, Sprint 21.1.1",
    status: "Ready for Development",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM"
  },
  {
    no: 85,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1182",
        target: "_blank",
        children: "TT4B-1182"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "(CoT Service) Comreg Order Capacity and Performance Testing:   Testing Support QA Perf Team",
    points: 5,
    sprint: "\nTT4B - PI=2, Sprint 21.1.2",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nDEV_ONLY"
  },
  {
    no: 86,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1110",
        target: "_blank",
        children: "TT4B-1110"
      },
      _owner: null,
      _store: {}
    },
    desc: "(TPD Admin TCE Backend Service) Client Ticket Charge Schedules",
    points: 13,
    sprint: "\nTT4B Sprint 16",
    status: "In Development",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nQA_Only,\nTCE"
  },
  {
    no: 87,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1105",
        target: "_blank",
        children: "TT4B-1105"
      },
      _owner: null,
      _store: {}
    },
    desc: "(TPD Admin TCE Backend Service) Rep Ticket Charge Schedules Comreg",
    points: 8,
    sprint: "\nTT4B Sprint 16",
    status: "In Development",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nQA_Only,\nTCE"
  },
  {
    no: 88,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1104",
        target: "_blank",
        children: "TT4B-1104"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "(CoT Service) Advisory Account Rep Ticket Charge Trade Results from ComReg ",
    points: 13,
    sprint: "\nTT4B Sprint 16",
    status: "In Development",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nQA_Only"
  },
  {
    no: 89,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1044",
        target: "_blank",
        children: "TT4B-1044"
      },
      _owner: null,
      _store: {}
    },
    desc: "Send ticket charge amount on CW order to Beta from R&R",
    points: 8,
    sprint: "\nTT4B Sprint 16",
    status: "Ready for Development",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nProration"
  },
  {
    no: 90,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-1043",
        target: "_blank",
        children: "TT4B-1043"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Send ticket charge amount on the order to Beta from CW Place Order service",
    points: 8,
    sprint: "\nTT4B Sprint 16",
    status: "Ready for Development",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nAFM,\nProration"
  },
  {
    no: 91,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT4B-781",
        target: "_blank",
        children: "TT4B-781"
      },
      _owner: null,
      _store: {}
    },
    desc: "R&R Fiserv: add audit view",
    points: 8,
    sprint: "",
    status: "Backlog",
    project: "Trading Team 4 - BETA\\BackOffice Team",
    labels: "\nTrading_UAT"
  },
  {
    no: 92,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT1C-1456",
        target: "_blank",
        children: "TT1C-1456"
      },
      _owner: null,
      _store: {}
    },
    desc: "Create a Runbook for scivantage trading system.",
    points: 5,
    sprint: "",
    status: "Backlog",
    project: "Trading Team 1 - Clientworks Trading",
    labels: ""
  },
  {
    no: 93,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT1C-1440",
        target: "_blank",
        children: "TT1C-1440"
      },
      _owner: null,
      _store: {}
    },
    desc: "Regression Testing TPD Admin Trade Edit  - OPMG Allocation ",
    sprint: "",
    status: "Backlog",
    project: "Trading Team 1 - Clientworks Trading",
    labels: "\nTeam4"
  },
  {
    no: 94,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT1C-1378",
        target: "_blank",
        children: "TT1C-1378"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Display Charges in SVI using Cost of Trade Service (Service Level Testing)",
    points: 5,
    sprint: "\nTT1C Sprint 16",
    status: "Ready for Testing",
    project: "Trading Team 1 - Clientworks Trading",
    labels: ""
  },
  {
    no: 95,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT1C-1358",
        target: "_blank",
        children: "TT1C-1358"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Run Trade Edit for Scivantage Orders - Existing Mutual Funds Edits Only (Service Level Testing)",
    points: 8,
    sprint: "\nTT1C Sprint 16",
    status: "Ready for Testing",
    project: "Trading Team 1 - Clientworks Trading",
    labels: ""
  },
  {
    no: 96,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT1C-1096",
        target: "_blank",
        children: "TT1C-1096"
      },
      _owner: null,
      _store: {}
    },
    desc: "Scivantage Gateway Service ",
    points: 5,
    sprint: "\nTT1C Sprint 14,\nTT1C Sprint 15",
    status: "Done",
    project: "Trading Team 1 - Clientworks Trading",
    labels: ""
  },
  {
    no: 97,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT1C-1067",
        target: "_blank",
        children: "TT1C-1067"
      },
      _owner: null,
      _store: {}
    },
    desc: "Routing Destination to SVI R&R (Service Level Testing)",
    points: 5,
    sprint: "\nTT1C Sprint 16",
    status: "In Development",
    project: "Trading Team 1 - Clientworks Trading",
    labels: "\nCDT"
  },
  {
    no: 98,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT1C-814",
        target: "_blank",
        children: "TT1C-814"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Run Trade Edit for Scivantage Orders - Existing Options edits only (Service Level Testing)",
    points: 8,
    sprint: "\nTT1C Sprint 15,\nTT1C Sprint 16",
    status: "Ready for Testing",
    project: "Trading Team 1 - Clientworks Trading",
    labels: "\nCDT,\nSparrow"
  },
  {
    no: 99,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/TT1C-813",
        target: "_blank",
        children: "TT1C-813"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Run Trade Edit for Scivantage Orders - Existing Equity edits only (Service LEvel Testing)",
    points: 8,
    sprint: "\nTT1C Sprint 15,\nTT1C Sprint 16",
    status: "Ready for Testing",
    project: "Trading Team 1 - Clientworks Trading",
    labels: "\nCDT,\nSparrow"
  },
  {
    no: 100,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/ST-16947",
        target: "_blank",
        children: "ST-16947"
      },
      _owner: null,
      _store: {}
    },
    desc: "ECMD - SRCH - CIC - CW NAO Distribution Channel - Include Master CF",
    points: 8,
    sprint: "\nECMD Program - Sprint 32",
    status: "Done",
    project: "Care Transformation Program",
    labels: ""
  },
  {
    no: 101,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/ST-15961",
        target: "_blank",
        children: "ST-15961"
      },
      _owner: null,
      _store: {}
    },
    desc: "ECMD - CHUB - RTE Component Update",
    points: 3,
    sprint: "\nECMD Program - Sprint 32",
    status: "Done",
    project: "Care Transformation Program",
    labels: ""
  },
  {
    no: 102,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/NNA-295",
        target: "_blank",
        children: "NNA-295"
      },
      _owner: null,
      _store: {}
    },
    desc: "NNA Widget - Data Attributes - 1.9 Release",
    sprint: "\nNNA Sprint 8",
    status: "In Development",
    project: "NNA by Advisor",
    labels: ""
  },
  {
    no: 103,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1901",
        target: "_blank",
        children: "DBM-1901"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Convert Dormant Account Task - Sponsor Account(s) successfully linked ",
    points: 2,
    sprint: "\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 104,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1896",
        target: "_blank",
        children: "DBM-1896"
      },
      _owner: null,
      _store: {}
    },
    desc: "Convert Dormant Account Task - Sponsor Account(s) not Relinked ",
    points: 3,
    sprint: "\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 105,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1883",
        target: "_blank",
        children: "DBM-1883"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trace Review (CLRWorks & ORT) - 529s Routing Rules Logic",
    points: 2,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 106,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1881",
        target: "_blank",
        children: "DBM-1881"
      },
      _owner: null,
      _store: {}
    },
    desc: "Convert Dormant Account Task - Dormant Account not Converted",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 107,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1880",
        target: "_blank",
        children: "DBM-1880"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Convert Dormant Account Task - Dormant Account successfully Converted ",
    points: 2,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 108,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1870",
        target: "_blank",
        children: "DBM-1870"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Convert Dormant Account Task - Notifications process (Task Creation process) ",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 109,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1860",
        target: "_blank",
        children: "DBM-1860"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business - Network change process ",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 110,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1850",
        target: "_blank",
        children: "DBM-1850"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (CLRWorks) - Alert Update after 30 Days ",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 111,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1849",
        target: "_blank",
        children: "DBM-1849"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (CLRWorks) - Refresh Trades for dormant account received from the trade blotter",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 112,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1848",
        target: "_blank",
        children: "DBM-1848"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (CLRWorks) - Trade Review Process ( Review Non-Flagged Trades)",
    points: 5,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 113,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1845",
        target: "_blank",
        children: "DBM-1845"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (CLRWorks) -  Trade Review Process (Review trades under each Alert ID) ",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 114,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1844",
        target: "_blank",
        children: "DBM-1844"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (CLRWorks) - Trade Review Process (Task Activation Logic)",
    points: 5,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 115,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1841",
        target: "_blank",
        children: "DBM-1841"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (CLRWorks) - Trade Review Process (Add comments to Flagged Trades)",
    points: 5,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 116,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1840",
        target: "_blank",
        children: "DBM-1840"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (CLRWorks) - Task Refreshed with Missing suitability Information ",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 117,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1839",
        target: "_blank",
        children: "DBM-1839"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (CLRWorks) - Alert Update ",
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 118,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1836",
        target: "_blank",
        children: "DBM-1836"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (CLRWorks) - All Flagged Trades ",
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 119,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1834",
        target: "_blank",
        children: "DBM-1834"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (CLRWorks) - Communication Section ",
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 120,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1831",
        target: "_blank",
        children: "DBM-1831"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (ORT) - Task Refreshed with Missing suitability Information ",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 121,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1828",
        target: "_blank",
        children: "DBM-1828"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (CLRWorks) - Due Date Logic  ",
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 122,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1797",
        target: "_blank",
        children: "DBM-1797"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business - Trade Review (ORT) - Refresh trades for dormant account received from the trade blotter",
    points: 1,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 123,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1796",
        target: "_blank",
        children: "DBM-1796"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (ORT) -  Trade Review Process (Task Activation Logic) ",
    points: 5,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 124,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1793",
        target: "_blank",
        children: "DBM-1793"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (ORT/ CLRWorks) -  Real-time update of comments to trade blotter ",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In Development",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 125,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1792",
        target: "_blank",
        children: "DBM-1792"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Trade blotter - Transaction Update (Post 30 days of no action on Dormant Account task)",
    points: 3,
    sprint: "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 13",
    status: "In Development",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 126,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1791",
        target: "_blank",
        children: "DBM-1791"
      },
      _owner: null,
      _store: {}
    },
    desc: "Convert Dormant Account Task - Alert Update after 30 days ",
    points: 1,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 127,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1790",
        target: "_blank",
        children: "DBM-1790"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (ORT) -  Alert Update after 30 Days",
    points: 1,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 128,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1787",
        target: "_blank",
        children: "DBM-1787"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (ORT) -  Trade Review Process (Review Non-Flagged Trades)",
    points: 1,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 129,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1785",
        target: "_blank",
        children: "DBM-1785"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (ORT) -  Trade Review Process (Review trades under each Alert ID) ",
    points: 5,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 130,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1782",
        target: "_blank",
        children: "DBM-1782"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (ORT) -  Trade Review Process (Add Comments to Flagged Trades) ",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 131,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1781",
        target: "_blank",
        children: "DBM-1781"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (CLRWorks) - List Page  ",
    points: 2,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 132,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1721",
        target: "_blank",
        children: "DBM-1721"
      },
      _owner: null,
      _store: {}
    },
    desc: "Convert Dormant Account Task - Direct business position files",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 133,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1541",
        target: "_blank",
        children: "DBM-1541"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (ORT) - Communication Panel ",
    points: 1,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "In QA",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 134,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1537",
        target: "_blank",
        children: "DBM-1537"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (ORT) - All Trades tied to an Alert ID ",
    points: 3,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 135,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1536",
        target: "_blank",
        children: "DBM-1536"
      },
      _owner: null,
      _store: {}
    },
    desc: "Direct Business Trade Review (ORT) - Non-Flagged Trades ",
    points: 5,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  },
  {
    no: 136,
    story: {
      type: "a",
      key: null,
      ref: null,
      props: {
        href: "https://lplfinancial.atlassian.net/browse/DBM-1534",
        target: "_blank",
        children: "DBM-1534"
      },
      _owner: null,
      _store: {}
    },
    desc:
      "Direct Business Trade Review (ORT) -  Pending Advisor Tasks Identifier ",
    points: 1,
    sprint:
      "\nConvert Dormant Acc-Sprint 11,\nConvert Dormant Acc-Sprint 12,\nConvert Dormant Acc-Sprint 13,\nConvert Dormant - Sprint 10",
    status: "Done",
    project: "Direct Business Mitigation",
    labels: ""
  }
];
